<section *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formProvider">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteProvider()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewProvider()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="providerContract.userNameCreate"
              [createDate]="providerContract.createDate" [userNameUpdate]="providerContract.userNameUpdate"
              [updateDate]="providerContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
            <div class="container">
              <div class="row">
                <div class="col type-document">
                  <app-custom-select formControlName="typeDocumentId" [labelText]="'Tipo Documento'"
                    [list]="listTypeDocument" [required]="true" [recovery]="true">
                  </app-custom-select>
                </div>
                <div class="col document">
                  <app-custom-input-text formControlName="document" [labelText]="'Documento'" [required]="true"
                    [recovery]="true" (onChangeTextOnBlur)="changeDocument()" [maxLength]="15"></app-custom-input-text>
                </div>
                <div class="digit-verification">
                  <app-custom-input-text formControlName="digitVerification" [labelText]="'DV'"></app-custom-input-text>
                </div>
                <div class="col type-person">
                  <app-custom-select formControlName="typePersonId" [labelText]="'Tipo Persona'" [list]="listTypePerson"
                    [required]="true" (onChangeSelect)="changeTypePerson($event)">
                  </app-custom-select>
                </div>
                <div class="update-document-btn d-flex align-items-end">
                  <app-custom-button [title]="'Actualizar Documento'" [icon]="'pi pi-sync'"
                    [disabled]="disableUpdateDocument" (onClick)="openChangeDocumentModal()"></app-custom-button>
                  <app-custom-modal #changeDocumentModal [label]="'Actualizar Documento'" [width]="'25rem'"
                    [header]="'Actualizar Documento'" [inputs$]="inputsForChangeDocumentModals$"
                    [children]="componentChangeDocumentModal" (params)="reloadProvider($event.reload)" hidden>
                  </app-custom-modal>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-custom-input-text formControlName="names" [labelText]="'Nombres'"
                    (onChangeTextOnBlur)="changeNames()" [maxLength]="75"></app-custom-input-text>
                </div>
                <div class="col">
                  <app-custom-input-text formControlName="lastNames" [labelText]="'Apellidos'"
                    (onChangeTextOnBlur)="changeNames()" [maxLength]="75"></app-custom-input-text>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-custom-input-text formControlName="businessName" [labelText]="'Razón Social'" [required]="true"
                    [maxLength]="150"></app-custom-input-text>
                </div>
                <div class="col">
                  <app-custom-input-text formControlName="comercialName" [labelText]="'Nombre Comercial'"
                    [maxLength]="100"></app-custom-input-text>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-custom-inputgroup [inputValue]="cityName" [labelText]="'Ciudad'"
                    [iconButton]="'pi pi-external-link'" [titleButton]="'Seleccionar Ciudad'" [required]="true"
                    (onClick)="openCitySelectionModal()"></app-custom-inputgroup>
                  <app-custom-modal #selectCity [label]="'Seleccionar'" [header]="'Selección de Ciudades'"
                    [children]="componentCitySelection" [inputs$]="inputsForSelectCityModal$" [output$]="output$"
                    (selectedItems)="setCityDepartment($event)" hidden></app-custom-modal>
                </div>
                <div class="col">
                  <app-custom-input-text [value]="departmentName" [labelText]="'Departamento'"
                    [disabled]="true"></app-custom-input-text>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-custom-input-text formControlName="address" [labelText]="'Dirección'" [required]="true"
                    [maxLength]="70"></app-custom-input-text>
                </div>
                <div class="col">
                  <app-custom-input-text formControlName="email" [labelText]="'Correo'"
                    [maxLength]="250"></app-custom-input-text>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <app-custom-input-text formControlName="phone" [labelText]="'Teléfono'" [required]="true"
                    [maxLength]="15"></app-custom-input-text>
                </div>
                <div class="col">
                  <app-custom-input-text formControlName="alterPhone" [labelText]="'Teléfono Alterno'"
                    [maxLength]="15"></app-custom-input-text>
                </div>
                <div class="col">
                  <app-custom-input-decimal formControlName="rateDiscount"
                    [labelText]="'Tarifa Dcto.'"></app-custom-input-decimal>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12">
            <div class="row d-flex justify-content-end">
              <div class="col-lg-10">
                <div class="row">
                  <div class="col">
                    <fieldset class="border p-2 mt-2">
                      <legend>Que Provee: <span class="text-danger">*</span></legend>
                      <div class="row">
                        <div class="checkbox-shopping mt-2">
                          <app-custom-checkbox formControlName="shopping" [labelText]="'Compras'"></app-custom-checkbox>
                        </div>
                        <div class="checkbox-subRent mt-2">
                          <app-custom-checkbox formControlName="subRent"
                            [labelText]="'SubAlquiler'"></app-custom-checkbox>
                        </div>
                        <div class="checkbox-transport mt-2">
                          <app-custom-checkbox formControlName="transport"
                            [labelText]="'Transporte'"></app-custom-checkbox>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                  <div class="col-auto">
                    <div class="row">
                      <div class="col change-state-select px-0">
                        <fieldset class="border p-2 mt-2">
                          <app-custom-select formControlName="active" [labelText]="'Cambiar Estado'"
                            [inputClass]="providerContract.active ? '' : 'state-inactive'" [list]="listProviderState"
                            [required]="true" (onChangeSelect)="changeState($event)">
                          </app-custom-select>
                        </fieldset>
                      </div>
                      <div class="col contact-modal-btn d-flex align-items-end justify-content-center my-2">
                        <app-custom-button [title]="'Contactos'" [label]="'Contactos'"
                          (onClick)="openContactModal()"></app-custom-button>
                        <app-custom-modal #contactModal [label]="'Contactos'" [header]="'Contactos'"
                          [inputs$]="inputsForContactModals$" [children]="componentContactModal" hidden>
                        </app-custom-modal>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <fieldset class="border p-2 mt-2">
                    <legend>Responsabilidades Fiscales:</legend>
                    <div class="row">
                      <div class="checkbox-ivaResponsible mt-3">
                        <app-custom-checkbox formControlName="swIvaResponsible" [labelText]="'Responsable Iva'"
                          (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
                      </div>
                      <div class="checkbox-declarant mt-3">
                        <app-custom-checkbox formControlName="swDeclarant"
                          [labelText]="'Declarante'"></app-custom-checkbox>
                      </div>
                      <div class="checkbox-simpleTaxRegime mt-3">
                        <app-custom-checkbox formControlName="swSimpleTaxRegime" [labelText]="'Reg.Simp.Trib.'"
                          (onChangeCheckBox)="changeIvaResponsible()"></app-custom-checkbox>
                      </div>
                      <div *ngIf="visibleGreatContributor" class="checkbox-greatContributor mt-3">
                        <app-custom-checkbox formControlName="swGreatContributor"
                          [labelText]="'Gran Contribuyente'"></app-custom-checkbox>
                      </div>
                      <div *ngIf="visibleGreatContributor" class="checkbox-ivaRetainer mt-3">
                        <app-custom-checkbox formControlName="swIvaRetainer"
                          [labelText]="'Retenedor de IVA'"></app-custom-checkbox>
                      </div>
                      <div *ngIf="visibleGreatContributor" class="checkbox-swSelfRetainer mt-3">
                        <app-custom-checkbox formControlName="swSelfRetainer"
                          [labelText]="'Autorretenedor'"></app-custom-checkbox>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div class="row" *ngIf="swPurchaseModule">
                  <fieldset class="border p-2 mt-2">
                    <legend>Facturación:</legend>
                    <div class="row align-items-end">
                      <div class="col-12 col-sm-5">
                        <app-custom-select formControlName="currencyId" [labelText]="'Moneda'"
                          [list]="listCurrency"></app-custom-select>
                      </div>
                      <div class="col-auto d-flex align-items-end">
                        <app-custom-checkbox formControlName="swExpirationDays"
                          [labelText]="'Días Venc.Part.'"></app-custom-checkbox>
                      </div>
                      <div class="col-auto expiration-days-input"
                        [hidden]="!formProvider.get('swExpirationDays')?.value">
                        <app-custom-input-number formControlName="expirationDays"
                          [labelText]="'Días Venc.'"></app-custom-input-number>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-md-10 col-sm-10 col-12 mt-2 ps-3">
            <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
              [rows]="1" [maxLength]="500"></app-custom-textarea>
          </div>
          <div class="save-btn col-lg-1 col-md-2 col-sm-2 col-12 d-flex align-items-end mt-2 pe-3">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [disabled]="disabledForm" [variant]="undefined"
              (onClick)="send()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>
<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>